//
// scroll vers le formulaire
//
let form = document.getElementById('form');

if (form) {
    let href = form.getAttribute('data-href');
    let targetE = href && document.getElementById(href);

    if (targetE) {
        window.scroll({
            behavior: 'smooth',
            top: targetE.getBoundingClientRect().top + window.scrollY,
        });
    }
}

//
// affichage conditionnel des checkboxes dépendantes et réinitialisation de leur valeur
//
document.querySelectorAll('[data-trigger]').forEach((field) => {
    const checkbox = document.getElementById(field.dataset.trigger);

    if (!checkbox || checkbox.type !== 'checkbox') {
        return;
    }

    const dependent = field.querySelector('input[type="checkbox"]');

    const toggle = () => {
        const checked = checkbox.checked;

        field.classList.toggle('d-none', !checked);

        if (!checked && dependent) {
            dependent.checked = false;
        }
    };

    checkbox.addEventListener('change', toggle);

    toggle();
});

//
// validation puis envoi des formulaires ayant la classe "ani-form"
//
let formSubmits = document.querySelectorAll('form.ani-form button[type=submit]');

formSubmits.forEach(formSubmit => {
    formSubmit.addEventListener('click', function (event) {
        let form = formSubmit.closest('form');

        if (!form.classList.contains('validated')) {
            event.preventDefault();

            if (form.checkValidity()) {
                if (document.querySelector('body').classList.contains('local') || !form.classList.contains('form-recaptcha')) {
                    form.classList.add('validated');
                    formSubmit.click();
                } else {
                    if (form.querySelector('.response')) {
                        grecaptcha.enterprise.ready(() => {
                            grecaptcha.enterprise.execute(global.form_recaptcha_key, {
                                action: 'submit',
                            }).then(token => {
                                document.querySelector('.response').value = token;
                                form.submit();
                            });
                        });
                    } else {
                        form.classList.add('validated');
                        formSubmit.click();
                    }
                }
            } else {
                form.classList.add('was-validated');
            }
        }
    });
});